// services/rc.js
import apiClient from './api';

/**
 * Fetches a list of products from an RC org.
 * Corresponds to: GET /api/products/rc/:orgId/
 */
export async function getRCProducts(orgId) {
  const response = await apiClient.get(`/products/rc/${orgId}/`);
  return response.data;
}

/**
 * Fetches the product model from an RC org.
 * Corresponds to: GET /api/products/rc/:orgId/product-model
 */
export async function getRCProductModel(orgId, products, use_existing) {
  const response = await apiClient.post(`/products/rc/${orgId}/product-model`, {
    products,
    use_existing,
  });
  return response.data;
}

/**
 * Fetches product attributes from an RC org.
 * Corresponds to: GET /api/products/rc/:orgId/attributes
 */
export async function getRCProductAttributes(orgId, products) {
  const response = await apiClient.post(`/products/rc/${orgId}/attributes`, { products });
  return response.data;
}

/**
 * Fetches pricebooks from an RC org.
 * Corresponds to: GET /api/products/rc/:orgId/pricebooks
 */
export async function getRCPricebooks(orgId, products) {
  const response = await apiClient.post(`/products/rc/${orgId}/pricebooks`, { products });
  return response.data;
}

/**
 * Fetches the dynamic revenue orchestrator from an RC org.
 * Corresponds to: GET /api/products/rc/:orgId/dynamic-revenue-orchestrator
 */
export async function getRCDynamicRevenueOrchestrator(orgId, products) {
  const response = await apiClient.post(`/products/rc/${orgId}/dynamic-revenue-orchestrator`, { products });
  return response.data;
}

/**
 * Fetches the fulfillment task assignment rule from an RC org.
 * Corresponds to: GET /api/products/rc/:orgId/fulfillment-task-rule
 */
export async function getRCFulfillmentTaskAssignmentRule(orgId) {
  const response = await apiClient.get(`/products/rc/${orgId}/fulfillment-task-rule`);
  return response.data;
}

/**
 * Fetches product pricing from an RC org.
 * Corresponds to: GET /api/products/rc/:orgId/pricing
 */
export async function getRCProductPricing(orgId, products) {
  const response = await apiClient.post(`/products/rc/${orgId}/pricing`, { products });
  return response.data;
}

/**
 * Fetches the object describe metadata from an RC org.
 * Corresponds to: GET /api/products/rc/:orgId/object-describe
 */
export async function getRCObjectDescribe(orgId) {
  const response = await apiClient.get(`/products/rc/${orgId}/object-describe`);
  return response.data;
}
